import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Card,
  CardHeader,
  CardBody,
  Table,
  Button,
  Row,
  Col,
  Badge,
  Form,
  FormGroup,
  Input,
  CardTitle
} from 'reactstrap';
import { getCommits } from '../../actions';
import { Link } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { BsCode } from 'react-icons/bs';
import K3ModalViewSource from '../../components/K3/K3ModalViewSource';

class CommitList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      commits: [],
      currentPage: 1,
      totalPages: 1,
      searchTerm: '',
      showSourceModal: false,
      selectedCommitForSource: null
    };
  }

  componentDidMount() {
    this.props.getCommits();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.commits) {
      this.setState({ commits: nextProps.commits });
    }
  }

  handleDelete = async (commitId) => {
    if (!window.confirm('Are you sure you want to delete this commit?')) {
      return;
    }
    
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/k3commit/${commitId}`, {
        method: 'DELETE'
      });
      
      if (!response.ok) {
        throw new Error('Failed to delete commit');
      }
      
      toast.success('Commit deleted successfully');
      // Cập nhật lại danh sách commits
      this.setState(prevState => ({
        commits: prevState.commits.filter(commit => commit._id !== commitId)
      }));
    } catch (error) {
      console.error('Error deleting commit:', error);
      toast.error('Failed to delete commit');
    }
  };

  handleShowSource = (commit) => {
    this.setState({
      selectedCommitForSource: commit,
      showSourceModal: true
    });
  };

  handleHideSource = () => {
    this.setState({
      selectedCommitForSource: null,
      showSourceModal: false
    });
  };

  render() {
    const { commits, currentPage, totalPages, searchTerm, showSourceModal, selectedCommitForSource } = this.state;

    return (
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Commits</CardTitle>
                <Form inline className="float-right">
                  <FormGroup>
                    <Input
                      type="text"
                      placeholder="Search commits..."
                      value={searchTerm}
                      onChange={this.handleSearch}
                    />
                  </FormGroup>
                </Form>
              </CardHeader>
              <CardBody>
                <Table responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>Title</th>
                      <th>Status</th>
                      <th>Created At</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {commits.map(commit => (
                      <tr key={commit._id}>
                        <td>{commit.title}</td>
                        <td>
                          <Badge color={
                            commit.status === 'active' ? 'success' :
                            commit.status === 'archived' ? 'warning' : 'danger'
                          }>
                            {commit.status}
                          </Badge>
                        </td>
                        <td>{new Date(commit.createdAt).toLocaleString()}</td>
                        <td>
                          <Link to={`/v1/commit/${commit._id}`} target="_blank">
                            <Button color="info" size="sm" className="mr-2">
                              View Details
                            </Button>
                          </Link>
                          <Button
                            color="danger"
                            size="sm"
                            onClick={() => this.handleDelete(commit._id)}
                            className="mr-2"
                          >
                            Delete
                          </Button>
                          <Button
                            color="secondary"
                            size="sm"
                            onClick={() => this.handleShowSource(commit)}
                          >
                            <BsCode className="me-1" /> Source
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="pagination">
                  <Button
                    color="primary"
                    onClick={() => this.handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </Button>
                  <span className="mx-3">
                    Page {currentPage} of {totalPages}
                  </span>
                  <Button
                    color="primary"
                    onClick={() => this.handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </Button>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <K3ModalViewSource
          show={showSourceModal}
          onHide={this.handleHideSource}
          data={selectedCommitForSource}
          title="Commit Source"
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  commits: state.commitReducer.commits
});

export default connect(mapStateToProps, { getCommits })(CommitList); 